function selectBase(state) {
  return state.inAppCards.customer
}

export const selectIsEditing = state => selectBase(state).isEditing
